import fp from 'lodash/fp'
import React from 'react'
import PropTypes from 'prop-types'
import { ContentLoader, Hr, Margin, Text, SmartImage } from 'shared/components'

import { FlipCard } from './components/flipCard'

const TournamentsOverviewComponent = ({ tournaments, loading }) => (
  <ContentLoader loading={loading}>
    {fp.map(
      ({ id, tournamentName }) => (
        <Margin key={id} all={3} inline>
          <FlipCard
            renderFront={() => (
              <>
                <figure>
                  <SmartImage name="atp-logo" />
                </figure>
                <Hr width="full" />
                <Text as="p">{tournamentName}</Text>
              </>
            )}
            renderBack={() => <Text as="p">{tournamentName}</Text>}
          />
        </Margin>
      ),
      tournaments
    )}
  </ContentLoader>
)

TournamentsOverviewComponent.propTypes = {
  tournaments: PropTypes.arrayOf(PropTypes.shape()),
  loading: PropTypes.bool.isRequired,
}

export default TournamentsOverviewComponent
